import { render, staticRenderFns } from "./ProductPackageVerticalContent.vue?vue&type=template&id=700efd7f&scoped=true"
import script from "./ProductPackageVerticalContent.vue?vue&type=script&lang=js"
export * from "./ProductPackageVerticalContent.vue?vue&type=script&lang=js"
import style0 from "./ProductPackageVerticalContent.vue?vue&type=style&index=0&id=700efd7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700efd7f",
  null
  
)

export default component.exports